import { Link } from 'react-router-dom';

export default function HomeScreen() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative h-[400px]">
        <img
          src="https://images.pexels.com/photos/158827/field-corn-air-frisch-158827.jpeg?auto=compress&cs=tinysrgb&w=1600"
          alt="Harvest field"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-white/85 flex flex-col items-center justify-center p-6">
          <h1 className="text-4xl font-bold text-gray-900 text-center mb-3">
            Welcome to Harvest House Tobique
          </h1>
          <p className="text-xl text-gray-800 text-center mb-2 font-semibold">
            Connecting people of compassion with people in need to make a difference
          </p>
          <p className="text-lg text-gray-700 text-center leading-relaxed max-w-3xl">
            We exist to meet the needs of the lost, lonely, hurting, and addicted through
            community support, recovery programs, and spiritual growth.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">
          How We Can Help
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          <Link
            to="/devotional"
            className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow border-t-4 border-[#B85C38]"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Daily Devotional</h3>
            <p className="text-gray-600 leading-relaxed">
              Start each day with a devotional focused on the 12-step path to recovery and spiritual growth.
            </p>
          </Link>

          <Link
            to="/events"
            className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow border-t-4 border-[#8B7355]"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Our Programs</h3>
            <p className="text-gray-600 leading-relaxed">
              Community meals, recovery meetings, Bible study, and more. Find what fits your journey.
            </p>
          </Link>

          <Link
            to="/notice-board"
            className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow border-t-4 border-amber-600"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Community Notices</h3>
            <p className="text-gray-600 leading-relaxed">
              Stay updated with the latest news, announcements, and updates from our community.
            </p>
          </Link>

          <Link
            to="/connect"
            className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow border-t-4 border-gray-700"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Connect With Us</h3>
            <p className="text-gray-600 leading-relaxed">
              Reach out to speak with a case manager who can help guide you toward healing and stability.
            </p>
          </Link>
        </div>

        <div className="bg-white rounded-xl p-8 mb-12 border-l-4 border-[#B85C38] mx-4">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">
            Our Weekly Schedule
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Monday</h3>
              <p className="text-gray-700 pl-2">• 10:00 AM - Overcomers 12-Step Group</p>
              <p className="text-gray-700 pl-2">• 5:00 PM - Community Meal</p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Tuesday - Friday</h3>
              <p className="text-gray-700 pl-2">• 10:00 AM - Overcomers 12-Step Group</p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Thursday</h3>
              <p className="text-gray-700 pl-2">• 12:00 PM - Community Meal</p>
              <p className="text-gray-700 pl-2">• 1:00 PM - Bible Study</p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Saturday</h3>
              <p className="text-gray-700 pl-2">• 7:00 PM - Celebration Service</p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Monday - Friday</h3>
              <p className="text-gray-700 pl-2">• 9:00 AM - 12:00 PM - Community Center Open</p>
            </div>
          </div>
        </div>

        <div className="bg-[#E8DDD0] rounded-xl p-8 border border-[#B85C38] mx-4">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-6">
            Stay Connected
          </h2>
          <p className="text-gray-700 text-center mb-6 leading-relaxed">
            Check the Daily Devotional each morning for inspiration, connect with our community through events,
            and reach out to a case manager whenever you need support.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/devotional"
              className="bg-[#B85C38] text-white px-6 py-3 rounded-lg font-bold text-center hover:bg-[#A34C28] transition-colors"
            >
              Read Today's Devotional
            </Link>
            <Link
              to="/connect"
              className="bg-gray-900 text-white px-6 py-3 rounded-lg font-bold text-center hover:bg-gray-800 transition-colors"
            >
              Connect With Us
            </Link>
            <Link
              to="/donate"
              className="bg-[#8B7355] text-white px-6 py-3 rounded-lg font-bold text-center hover:bg-[#7B6345] transition-colors"
            >
              Make a Donation
            </Link>
          </div>
        </div>
      </div>

      <footer className="bg-gray-900 py-12 mt-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-400 mb-2">Harvest House Tobique is a Registered Charity</p>
          <p className="text-gray-400">© 2024 Harvest House Tobique. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
